import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const counterWrapperSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    flexShrink: 0,
    '& .MuiTypography-caption': {
        whiteSpace: 'nowrap',
        color: theme.palette.neutral[500],
    },
    // It used to disappear below `lg` — which is exactly where it matters most: a phone handed a
    // hundred-row page had no way to ask for fewer.
};

export const selectSx: SxProps<Theme> = {
    background: 'transparent',
    height: '26px',
    fontSize: '12px',
    fontWeight: 500,
    borderRadius: '6px',
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-focused': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& .MuiSelect-select': {
        py: 0,
        pl: 1,
        pr: '22px !important',
        minHeight: 'unset !important',
    },
    '& .MuiSvgIcon-root': {
        color: theme.palette.neutral[400],
        right: '2px',
    },
};
